/* no_multi_edit.icon.svg.js */

module.exports = {
    icon: `            
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg">
            <g>
                <ellipse fill-opacity="0" ry="45%" rx="45%" id="svg_1" cy="50%" cx="50%" stroke-width="6%" stroke="#000" fill="#fff"/>
                <line stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_2" y2="100" x2="108" y1="24" x1="22" stroke-width="6%" stroke="#000" fill="none"/>
                <line stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_3" y2="100" x2="22" y1="22" x1="108" stroke-width="6%" stroke="#000" fill="none"/>
            </g>
        </svg>
    `,
};
